<template>
    <div :class="$style.page_toggles">
        <IconButton
            :class="props.currentPage <= 1 ? $style.disabled_override : ''"
            color="carbon-400"
            size="m"
            icon="chevron-left"
            :interfaceTarget="`click-page-${prevPage}`"
            :to="getPageLink(prevPage)"
        />

        <template
            v-for="(item, index) in visiblePageItems"
            :key="`${item}-${index}`"
        >
            <Button
                v-if="typeof item === 'number'"
                size="m"
                :to="getPageLink(item)"
                :interfaceTarget="`click-page-${item}`"
                :label="item"
                :color="props.currentPage === item ? 'purple-400-flat' : 'carbon-400'"
            />
            <Typography
                v-else
                type="label"
                size="m"
                accent
                :responsive="false"
                :class="$style.ellipsis"
            >
                ...
            </Typography>
        </template>
        <IconButton
            :class="props.currentPage >= props.totalPages ? $style.disabled_override : ''"
            color="carbon-400"
            size="m"
            :interfaceTarget="`click-page-${nextPage}`"
            icon="chevron-right"
            :to="getPageLink(nextPage)"
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import Button from '@/components/Buttons/Button.vue'
import IconButton from '@/components/Buttons/IconButton.vue'
import Typography from '@/components/Typography.vue'

import { getVisiblePageItems } from './get-visible-pages'

const props = withDefaults(
    defineProps<{
        totalPages?: number
        currentPage?: number
        getPageLink: (page: number) => RouteLocationRaw
    }>(),
    {
        totalPages: 5,
        currentPage: 1,
    },
)

const prevPage = computed<number>(() => props.currentPage - 1)
const nextPage = computed<number>(() => props.currentPage + 1)
const visiblePageItems = computed(() => getVisiblePageItems(props.currentPage, props.totalPages))
</script>
<style module>
.page_toggles {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 16px 0;
}

.disabled_override {
    color: var(--white-20);
    --main: var(--carbon-400);
    pointer-events: none;
}

.ellipsis {
    color: var(--white-60);
}

@media (--desktop-small-plus) {
    .page_toggles {
        padding: 8px 0;
    }
}
</style>
